var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Box, Divider, useTheme } from '@mui/material';
const PageLayout = (_a) => {
    var { children, component: Component = Box, disableOuterPadding = false, spacing, transparent = true, maxWidth, footer, fullHeight = false } = _a, rest = __rest(_a, ["children", "component", "disableOuterPadding", "spacing", "transparent", "maxWidth", "footer", "fullHeight"]);
    const theme = useTheme();
    const padding = spacing === 'page' ? 2 : 0;
    return (_jsxs(Box, { display: 'flex', flexDirection: 'column', position: 'relative', justifyContent: 'flex-start', width: '100%', p: disableOuterPadding ? 0 : padding, minHeight: '100%', maxHeight: fullHeight ? 'unset' : '100%', bgcolor: transparent ? 'transparent' : theme.palette.background.paper, children: [_jsx(Component, Object.assign({ sx: {
                    display: 'flex',
                    padding: padding,
                    paddingTop: padding / 2,
                    flexDirection: 'column',
                    minHeight: '100%',
                    maxHeight: '100%',
                    width: '100%',
                    marginInline: 'auto',
                    flexGrow: 1,
                    maxWidth: maxWidth ? theme.breakpoints.values[maxWidth] : 'initial',
                } }, rest, { children: children })), footer && (_jsxs(Box, { component: 'footer', zIndex: 1, sx: { position: 'sticky', bottom: 0, background: theme.palette.background.paper }, children: [_jsx(Divider, {}), _jsx(Box, { p: 1, paddingInline: padding, marginInline: 'auto', sx: { maxWidth: maxWidth ? theme.breakpoints.values[maxWidth] : 'initial' }, children: footer })] }))] }));
};
export default memo(PageLayout);
